import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Briefcase, Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { waLink } from "@/lib/conecta";

const FIT = { alto: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400", medio: "bg-amber-500/15 text-amber-700 dark:text-amber-400", bajo: "bg-slate-500/15 c-text-2" };
const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const SuggestionCard = ({ s, i, need, query }) => {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const c = s.contact;
  const createOpp = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/opportunities", { title: cap(need), description: `Desde "Dame una opción": ${query}`, resolver_id: c.id, stage: "nuevo_por_revisar" });
      toast.success("Negocio creado");
      nav(`/conecta/negocios/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div data-testid={`suggestion-card-${i}`} className="c-card p-4 space-y-2.5">
      <div className="flex items-start gap-3">
        <span className="font-mono text-xs c-muted pt-1">{i + 1}</span>
        <div className="flex-1 min-w-0">
          <Link to={`/conecta/red/${c.id}`} data-testid={`suggestion-name-${i}`} className="font-semibold hover:underline">{c.name}{c.nickname ? ` "${c.nickname}"` : ""}</Link>
          <p className="text-xs c-text-2">{[c.company, c.city, ...c.specialties.slice(0, 2)].filter(Boolean).join(" · ")}</p>
        </div>
        <span data-testid={`suggestion-fit-${i}`} className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded ${FIT[s.fit]}`}>Encaje {s.fit}</span>
      </div>
      <p data-testid={`suggestion-reason-${i}`} className="text-sm">{s.reason}</p>
      {s.opportunities_in_common.length > 0 && <p className="text-xs c-muted">Negocios previos: {s.opportunities_in_common.map((o) => o.title).join(" · ")}</p>}
      <div className="grid grid-cols-2 gap-2">
        <a data-testid={`suggestion-whatsapp-btn-${i}`} href={waLink(c.whatsapp || c.phone, s.intro_message)} target="_blank" rel="noopener noreferrer"
          className="py-2.5 rounded-xl bg-emerald-600 text-white text-sm font-semibold flex items-center justify-center gap-1.5 active:scale-[0.98] transition-transform">
          <MessageCircle className="w-4 h-4" /> Presentar
        </a>
        <button data-testid={`suggestion-create-opp-btn-${i}`} disabled={busy} onClick={createOpp} className="py-2.5 rounded-xl c-card text-sm font-semibold flex items-center justify-center gap-1.5">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Briefcase className="w-4 h-4 c-accent" />} Crear negocio
        </button>
      </div>
      {!(c.whatsapp || c.phone) && <p className="text-[11px] c-muted">Sin teléfono: WhatsApp te pedirá elegir el chat.</p>}
    </div>
  );
};
